var utils = {
  head: {
    title(title, root) {
      var role = app.utils.auth.currentUser && app.utils.auth.currentUser.role;
      var project = role === 'client' && root.tags['module-sidebar'] ? root.tags['module-sidebar'].project : '';
      var resource_name = project ? project.name : spat.config.head.title;
      return title ? `${title} | ${resource_name}` : spat.config.head.ogp.site_name;
    }
  },
  wait(time) {
    return new Promise((resovle) => {
      setTimeout(resovle, time);
    });
  },

  '$get': (obj, key) => {
    return key.split('.').reduce(function (t, v) {
      return t && t[v];
    }, obj);
  },

  auth: {
    isSignIn() {
      return !!firebase.auth().currentUser;
    },
    validateOperator() {
      if (app.utils.auth.currentUser.role !== "operator") {
        throw new AuthError();
      }
    },
  },

  _LANGUAGE_STORAGE_KEY: 'i18next.language',
  saveLanguage() {
    const language = i18next.language;
    try {
      sessionStorage.setItem(utils._LANGUAGE_STORAGE_KEY, language);
      localStorage.setItem(utils._LANGUAGE_STORAGE_KEY, language);
    }
    catch (e) {
      // storage アクセス失敗
    }
  },

  async loadLanguage() {
    try {
      const language = sessionStorage.getItem(utils._LANGUAGE_STORAGE_KEY) || localStorage.getItem(utils._LANGUAGE_STORAGE_KEY);
      await i18next.changeLanguage(language);
      riot.update();
    }
    catch (e) {
      // storage アクセス失敗
    }
  },
  // 指定言語の値を返す
  getI18nValue(obj, key, lang = 'ja') {
    // image.url 的なやつに対応
    const keys = key.split('.');
    // 最初の key だけ image_en 的にする
    keys[0] = lang === 'ja' ? keys[0] : `${keys[0]}_${lang}`;
    let value = obj;
    for (key of keys) {
      value = value[key];
      if (value == null) return value;
    }
    return value;
  },
  // company role の日本語表記を返す
  getCompanyRoleLabel(role) {
    return app.data.constants.company_roles.find(r => r.id === role).name;
  },
  // project role の日本語表記を返す
  getProjectRoleLabel(role) {
    return app.data.constants.project_roles.find(r => r.id === role).name;
  },
  // operatorごとに登録している利用可能券種とマッチしたconstantsデータを返す
  getProviderOptions(selected) {
    return app.data.constants.point_providers.filter(item => selected.some(p => p.point_provider === item.id));
  },
  // operatorごとに登録している利用可能券種とマッチしたconstantsデータにテスト用券種を追加して返す
  getProviderOptionsWithTest(selected) {
    let matched = this.getProviderOptions(selected);
    // テスト用プロバイダーを選択肢に生やす
    let test_provider = app.data.constants.point_providers.find(p => p.id === "test_point_provider");
    if (test_provider) {
      matched.push(test_provider);
    }
    return matched;
  },

  validator: {
    validate(data, formats) {
      for (const key in data) {
        const { isValid, type, message } = this.validateItem(data[key], formats[key]);
        if (!isValid) {
          return {
            isValid,
            target: {
              key,
              item: data[key],
              type,
              message,
            },
          };
        }
      }
      return {
        isValid: true,
      };
    },

    validateItem(item, options = {}) {
      if (!this[options.type || 'string']) {
        throw new Error(`"type: ${options.type}" is invalid type`);
      }
      return this[options.type || 'string'](item, options);
    },

    // YYYY-MM-DDTHH:mm:ss(.SSS)?(Z|+00:00)
    DATE_TIME_REGEXP: /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}\:[0-9]{2}(\.[0-9]+)?(Z|(\+|\-)[0-9]{2}\:[0-9]{2})$/,
    // 日付のバリデーション
    date(value, { required } = {}) {
      if (value === '') {
        if (required) {
          return { isValid: false, message: '必須項目です。', type: 'shortage' };
        }
        else {
          return { isValid: true };
        }
      }
      const time = new Date(value).getTime();
      // 文字列表現があってるか
      if (!this.DATE_TIME_REGEXP.test(value)) {
        return {
          isValid: false,
          message: '日付のフォーマットが間違っています。\n期待されるフォーマット:\nYYYY-MM-DDTHH:mm:ssZ もしくは YYYY-MM-DDTHH:mm:ss+HH:mm\n\n例) 2022-01-01T15:00:00+09:00'
        };
      }
      // JS で使える値か
      if (Number.isNaN(time)) {
        return {
          isValid: false,
          message: '不正な日付です。\n正しい日付を入力してください。'
        };
      }
      return { isValid: true };
    },

    // 文字列のバリデーション
    string(value, { minlength = -Infinity, maxlength = Infinity, values = [], required } = {}) {
      if (value === '') {
        if (required) {
          return { isValid: false, message: '必須項目です。', type: 'shortage' };
        }
        else {
          return { isValid: true };
        }
      }

      if (value.length < minlength) {
        return {
          isValid: false,
          message: `文字数が不足しています。\n${minlength} 文字以上の文字列を入力してください。`,
        };
      }

      if (value.length > maxlength) {
        return {
          isValid: false,
          message: `規定の文字数を超えています。\n${maxlength} 文字以下の文字列を入力してください。`,
        };
      }

      if (values.length) {
        if (!values.includes(value)) {
          const message = values.length === 1 ? `${values[0]} のみ入力可能です。` : `${values.join(', ')} のいずれかを入力してください。`;
          return {
            isValid: false,
            message: `不正な文字列です。\n${message}`,
          };
        }
      }

      return { isValid: true };
    },

    INT_REGEXP: /^\-?[0-9]+$/,
    // 整数のバリデーション
    int(value, { min = -Infinity, max = Infinity, required } = {}) {
      if (value === '') {
        if (required) {
          return { isValid: false, message: '必須項目です。', type: 'shortage' };
        }
        else {
          return { isValid: true };
        }
      }

      if (!this.INT_REGEXP.test(value)) {
        return {
          isValid: false,
          message: '整数以外の文字列が入力されています。\n整数を入力してください。',
        };
      }

      const int = Number(value);

      if (int < min || int > max) {
        return {
          isValid: false,
          message: `規定の数値の範囲外です。\n${min} 以上 ${max} 以下の数値を入力してください。`,
        };
      }

      return { isValid: true };
    }
  },
  getInputAmountValidation(provider_ids = []) {
    return provider_ids.reduce((result, id) => {
      let validation = app.data.validation[id]?.amount?.input;
      if (validation) {
        result.min = Math.max(result.min, validation.min);
        result.max = Math.min(result.max, validation.max);
      }
      result.title = `${result.min}〜${result.max}の整数を入力してください`;
      return result;
    }, { min: 0, max: 1000000 });
  },
  async openModalDialog(query) {
    query.dismissible = false;
    var modal = await spat.modal.open('modal-dialog', query);
    var result = await modal.waitClose();
    return result;
  },
  async openModalInput(query) {
    if (query.dismissible === undefined) query.dismissible = false;
    var modal = await spat.modal.open('modal-input-form', query);
    return modal;
  },
  setLastSeenItem({ company_id, project_id }) {
    var storage_item = this.getLastSeenItem();
    var item = {
      [company_id]: project_id,
    };
    Object.assign(storage_item, item);
    localStorage.setItem(app.data.storage_key.last_seen, JSON.stringify(storage_item));
  },
  getLastSeenItem() {
    try {
      var storage_item = localStorage.getItem(app.data.storage_key.last_seen);
      if (storage_item === null) {
        return {};
      }
      storage_item = JSON.parse(storage_item);
      return storage_item ? storage_item : {};
    }
    catch (e) {
      console.error(e);
      return {};
    }
  },
  removeLastSeenItem() {
    localStorage.removeItem(app.data.storage_key.last_seen);
  },
  copyToClipBoard(text) {
    return navigator.clipboard.writeText(text);
  },
  isEqualUniqueArrays(arr1, arr2) {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);

    if (set1.size !== set2.size) return false;
    for (const item of set1) {
      if (!set2.has(item)) return false;
    }
    return true;
  },

  // 署名付きアップロード
  uploadImage: async ({ file, api, limit }) => {

    //- 拡張子を取得
    var index = file.name.lastIndexOf('.');
    var file_type = file.name.slice(index + 1);

    // headers
    var headers = {
      "Content-Type": file.type,
    };
    if (limit) {
      headers["x-goog-content-length-range"] = `${limit.min},${limit.max}`;
    }

    try {
      //- 署名付きURLを取得
      var { signed_url } = await api.post({
        content_type: file.type,
        file_type
      });
      //- pathを取得する
      var path = signed_url.split('/').slice(-1)[0].split('?')[0];
      try {
        //- 署名付きURLにデーターをアップロードする
        await fetch(signed_url, {
          method: "PUT",
          headers,
          body: file
        });
        return path;
      }
      catch (e) {
        console.error(e.message);
        spat.modal.alert('アップロードに失敗しました');
        return;
      }
    }
    catch (e) {
      console.error(e.message);
      spat.modal.alert(e.message);
      return;
    }
  },
  permission: {
    // 渡された権限があるかチェック
    has: (permission, { company_id, project_id }) => {
      // company role
      if (permission === 'company_owner') {
        return app.utils.permission.isOwner(company_id);
      }
      else if (permission === 'company_member') {
        return (app.utils.permission.isOwner(company_id) || app.utils.permission.isMember(company_id));
      }
      else if (permission === 'company_guest') {
        return (app.utils.permission.isOwner(company_id) || app.utils.permission.isMember(company_id) || app.utils.permission.isGuest(company_id));
      }

      // project role
      else if (permission === 'project_admin') {
        return app.utils.permission.isAdmin({ company_id, project_id });
      }
      else if (permission === 'project_writer') {
        return (app.utils.permission.isAdmin({ company_id, project_id }) || app.utils.permission.isWriter({ company_id, project_id }));
      }
      else if (permission === 'project_reader') {
        return (app.utils.permission.isAdmin({ company_id, project_id }) || app.utils.permission.isWriter({ company_id, project_id }) || app.utils.permission.isReader({ company_id, project_id }));
      }
    },

    // 最上位権限
    // operator / client
    isOperator: () => {
      return app.utils.auth.currentUser.permission.user_role === 'operator';
    },

    // company role
    // owner / member / guest
    isOwner: (company_id) => {
      if (app.utils.permission.isOperator()) return true;

      var company_role = app.utils.auth.currentUser.permission.company_roles[company_id];
      return company_role === 'owner';
    },

    isMember: (company_id) => {
      if (app.utils.permission.isOperator()) return true;

      var company_role = app.utils.auth.currentUser.permission.company_roles[company_id];
      return company_role === 'member';
    },

    isGuest: (company_id) => {
      if (app.utils.permission.isOperator()) return true;

      var company_role = app.utils.auth.currentUser.permission.company_roles[company_id];
      return company_role === 'guest';
    },

    // project role(company role が owner の場合はそちらが優先される)
    // admin / writer / reader
    isAdmin: ({ company_id, project_id }) => {
      if (app.utils.permission.isOwner(company_id)) return true;

      var project_role = app.utils.auth.currentUser.permission.project_roles[project_id];
      return project_role === 'admin';
    },

    isWriter: ({ company_id, project_id }) => {
      if (app.utils.permission.isOwner(company_id)) return true;

      var project_role = app.utils.auth.currentUser.permission.project_roles[project_id];
      return project_role === 'writer';
    },

    isReader: ({ company_id, project_id }) => {
      if (app.utils.permission.isOwner(company_id)) return true;

      var project_role = app.utils.auth.currentUser.permission.project_roles[project_id];
      return project_role === 'reader';
    },
  },
};
class AuthError extends Error {
  constructor(...args) {
    super(...args);
    this.status = 403;
  }
}

export default utils;

